export function hxEmitter(emitterElement){
  const hxEvent = emitterElement.dataset.hxEvent;
  const events = hxEvent ? hxEvent.split(',') : []

  function emitEvent(){
    const emitName = emitterElement.dataset.hxEmit;
    const elements = document.querySelectorAll(`[hx-trigger*="${emitName}"]`);
    elements.forEach(element => {
      const triggers = element.getAttribute('hx-trigger').split(',').map(s => s.trim());
      if (triggers.includes(emitName)) {
        // Abort previous request before triggering a new one
        htmx.trigger(element, 'htmx:abort');
        htmx.trigger(element, emitName);
      }
    });
  }

  events.forEach((event) => {
    emitterElement.addEventListener(event, (e) => {
      emitEvent()
    });
  });

  if(events.length === 0){
    // No events calling it immediatly
    emitEvent();
  }
}